import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  "class": "fconnect_input_options"
};
var _hoisted_2 = {
  style: {
    "float": "left"
  }
};
var _hoisted_3 = {
  key: 0,
  style: {
    "float": "right",
    "color": "#8492a6",
    "font-size": "13px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_option_group = _resolveComponent("el-option-group");
  var _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_select, {
    multiple: $props.field.is_multiple,
    clearable: "",
    filterable: "",
    placeholder: $props.field.placeholder,
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.value = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.field.options, function (group) {
        return _openBlock(), _createBlock(_component_el_option_group, {
          key: group.label,
          label: group.label
        }, {
          "default": _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, function (item) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.title,
                value: item.id
              }, {
                "default": _withCtx(function () {
                  return [_createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1 /* TEXT */), $props.field.show_id ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.id), 1 /* TEXT */)) : _createCommentVNode("v-if", true)];
                }),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]);
            }), 128 /* KEYED_FRAGMENT */))];
          }),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["multiple", "placeholder", "modelValue"])]);
}